












































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Schedule, StudentReservable } from '@/modules/studentCalendar';
import moment from 'moment';
import { Person } from '@/models/person';
import { CalendarEvent } from '@/components/student/baseCalendar.vue';

interface ScheduleGroup {
  date: string;
  schedules: Schedule[];
}

@Component
export default class ReportEditor extends Vue {
  @Prop({ required: true })
  private studentId: string;

  @Prop({ required: true })
  private reservableList: Schedule[];

  @Prop({ required: false, default: () => [] })
  private selectedIdList: number[];

  @Prop({ required: true })
  private isSelectable: boolean;

  @Prop({required: false, default: () => []})
  private reservedList: CalendarEvent[];

  private selectedModel: Set<number> = new Set();
  private selectedReservableList: Schedule[] = [];

  @Watch('reservableList')
  private onReservableList(val: number[]) {
    this.selectedReservableList = this.reservableList
      .filter((item) => this.selectedModel.has(item.scheduleId));
  }

  @Watch('selectedIdList')
  private onSelectedList(val: number[]) {
    this.selectedModel = new Set(val);
    this.selectedReservableList = this.reservableList
      .filter((item) => this.selectedModel.has(item.scheduleId));
  }

  get displayedReservableList() {
    return this.reservableList.reduce((list, item) => {
      const date = new Date(item.unixtimeDate * 1000);
      const formattedDate = moment(date).format('YYYY年M月D日');
      const findItem = list.find((check) => check.date === formattedDate);
      if (findItem) {
        findItem.schedules.push(item);
        findItem.schedules.sort((a, b) => {
          const startTimeA = this.getTimeFromString(new Date(a.unixtimeDate * 1000), a.stringStart);
          const startTimeB = this.getTimeFromString(new Date(b.unixtimeDate * 1000), b.stringStart);
          if (startTimeA < startTimeB) { return -1; }
          if (startTimeA > startTimeB) { return 1; }

          const endTimeA = this.getTimeFromString(new Date(a.unixtimeDate * 1000), a.stringEnd);
          const endTimeB = this.getTimeFromString(new Date(b.unixtimeDate * 1000), b.stringEnd);
          if (endTimeA < endTimeB) { return -1; }
          if (endTimeA > endTimeB) { return 1; }

          if (a.tutorName < b.tutorName) { return -1; }
          if (a.tutorName > b.tutorName) { return 1; }

          return 0;
        });
      } else {
        list.push({
          date: formattedDate,
          schedules: [ item ],
        });
      }
      return list;
    }, [] as ScheduleGroup[]).sort((a, b) => {
      if (a.date < b.date) { return -1; }
      if (a.date > b.date) { return 1; }
      return 0;
    });
  }

  private isNotReservable(schedule: Schedule) {
    // 選択中の場合は解除可能とする
    if (this.selectedModel.has(schedule.scheduleId)) {
      return false;
    }

    if (schedule.reservers.length >= schedule.capacity) {
      return true;
    }

    const date = new Date(schedule.unixtimeDate * 1000);
    date.setHours(0); date.setMinutes(0); date.setSeconds(0);
    // 予約可能コマ数でチェックする
    const studentReservableList: StudentReservable[] = this.$store.state.studentCalendar.studentReservableList;
    const target = studentReservableList.filter((studentReservable) => {
      return studentReservable.startDate <= date && studentReservable.endDate >= date;
    });

    if (target && target.length > 0) {
      // 該当日の予約可能コマ数がすべて予約可能かチェック
      const notReservable = !target.every((studentReservable) => {
        const selectedCount = this.selectedReservableList.reduce((count, selectedReservable) => {
          const checkDate = new Date(selectedReservable.unixtimeDate * 1000);
          const checkTime = this.getTimeFromString(checkDate, selectedReservable.stringStart);
          if (checkTime >= studentReservable.startDate && checkTime <= studentReservable.endDate) {
            count++;
          }
          return count;
        }, 0);
        return studentReservable.reservableCount - selectedCount > 0;
      });
      if (notReservable) {
        return true;
      }
    } else {
      //  予約可能コマ数の範囲外の場合、予約不可
      return true;
    }

    // 予約済みとの時間重複チェック
    const targetDate = new Date(schedule.unixtimeDate * 1000);
    const startTime = this.getTimeFromString(targetDate, schedule.stringStart);
    const endTime = this.getTimeFromString(targetDate, schedule.stringEnd);

    if (this.reservedList.some(
        (reservedData) => startTime < reservedData.endDate && endTime > reservedData.startDate)
    ) {
      return true;
    }

    return false;
  }

  private getTimeFromString(date: Date, stringTime: string): Date {
    const splitTime = stringTime.split(':');
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parseInt(splitTime[0], 10),
      parseInt(splitTime[1], 10)
    );
  }

  private isAlreadyReserved(schedule: Schedule) {
    if (!this.isSelectable) {
      return true;
    }
    const findReserver = schedule.reservers.find((reserver: Person) => {
      return reserver.id === this.studentId;
    });
    return findReserver !== undefined;
  }

  private makeCapacity(schedule: Schedule) {
    const num = schedule.capacity - schedule.reservers.length;
    return `残${ num < 0 ? 0 : num } / 定員${ schedule.capacity }人`;
  }

  private clickReservationTag(schedule: Schedule) {
    if (!this.isSelectable) {
      return;
    }

    if (this.isAlreadyReserved(schedule)) {
      return;
    }

    if (this.isNotReservable(schedule)) {
      return;
    }

    if (this.selectedModel.has(schedule.scheduleId)) {
      this.selectedModel.delete(schedule.scheduleId);
    } else {
      this.selectedModel.add(schedule.scheduleId);
    }

    this.$emit('update:selectedIdList', [...this.selectedModel]);

    this.$forceUpdate();
  }
}
